<sb-button [dropdownItems]="switcherItems"
           [message]="selectedSwitcherItem?.messageXs"
           customClasses="badge badge-success badge-square"
           dropdownClasses="dropdown-sm-fullscreen"
           [tooltipText]="'SB_Switch_User_Type'"
           tooltipPlacement="bottom"
           (onClick)="onButtonClick($event)"></sb-button>
